module.exports = __webpack_public_path__ + "static/media/openet.545c6d59.png";